import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./styles.module.css";

const CollapsableSection = ({
  isOpen,
  onClose,
  title,
  content,
  actions,
  bodyHeight,
  background = "white",
}) => {
  return (
    <div
      className={`${styles.collapsable_comp} ${isOpen ? "" : styles.close} ${
        bodyHeight ? "has_fixed_height" : ""
      }`}
      style={{ backgroundColor: background }}
    >
      <div
        className={`${styles.comp_header} ${
          actions?.length === 0 ? styles.no_btn : ""
        }`}
        onClick={onClose}
      >
        <p className={styles.comp_heading}>{title}</p>

        <div className={styles.comp_actions}>
          {Array.isArray(actions) && actions.length > 0 && (
            <div
              className={styles.actions_wrapper}
              onClick={(e) => e.stopPropagation()}
            >
              {React.Children.map(actions, (action) =>
                React.isValidElement(action)
                  ? React.cloneElement(action, {
                      className: `${styles.action} ${
                        action.props["data-selected"] ? styles.selected : ""
                      }`,
                    })
                  : action
              )}
            </div>
          )}

          <FontAwesomeIcon className={styles.drop_icon} icon={faChevronDown} />
        </div>
      </div>

      <div
        className={styles.comp_body}
        style={{ height: isOpen ? bodyHeight : "0px" }}
      >
        {content}
      </div>
    </div>
  );
};

export default CollapsableSection;
